"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getId = exports.getCardLast4 = exports.getCardExpiryYear = exports.getCardExpiryMonth = exports.getCardBrand = exports.getCard = void 0;
var _objects = require("../../utils/objects");
const getId = paymentMethod => (0, _objects.getObjectProperty)(paymentMethod, 'id');
exports.getId = getId;
const getCard = paymentMethod => (0, _objects.getObjectProperty)(paymentMethod, 'card');
exports.getCard = getCard;
const getCardLast4 = paymentMethod => (0, _objects.getObjectProperty)(getCard(paymentMethod), 'last4');
exports.getCardLast4 = getCardLast4;
const getCardBrand = paymentMethod => (0, _objects.getObjectProperty)(getCard(paymentMethod), 'brand');
exports.getCardBrand = getCardBrand;
const getCardExpiryYear = paymentMethod => (0, _objects.getObjectProperty)(getCard(paymentMethod), 'exp_year');
exports.getCardExpiryYear = getCardExpiryYear;
const getCardExpiryMonth = paymentMethod => (0, _objects.getObjectProperty)(getCard(paymentMethod), 'exp_month');
exports.getCardExpiryMonth = getCardExpiryMonth;